import { CalendarEvent } from '@highlight/common'

export type CalendarProvider = 'google' | 'microsoft' | undefined

/**
 * Gets the calendar provider for an event by looking up the calendar data
 * @param event - The calendar event
 * @param calendarsData - Raw calendar data from the backend
 * @returns The provider name or undefined if not found
 */
export function getEventProvider(
  event: CalendarEvent,
  calendarsData?: Array<{ id: string; providerName: 'google' | 'microsoft' }>,
): CalendarProvider {
  if (!event.calendarId || !calendarsData) {
    return undefined
  }

  const calendar = calendarsData.find((cal) => cal.id === event.calendarId)
  return calendar?.providerName
}
